import { RootState } from 'editor/src/store/index';

const getHostPickerActive = (state: RootState): boolean => state.editor.hostPickerActive;

export default getHostPickerActive;
